import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const CustomDonutChart = ({color, value} : {color: string, value: number}) => {

    const getSubtitles = () => {
        return `<span style="font-size: 15px; font-weight: bold">${value}%</span>`;
    }

    const options = {
        exporting: {
            enabled: false,
        },
        accessibility: {
            enabled: false,
        },
        tooltip: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        chart: {
            type: 'pie',
            width: 78,
            height: 78,
        },
        title: undefined,
        subtitle: {
            text: getSubtitles(),
            floating: true,
            useHTML: true,
            verticalAlign: 'middle',
            y: 10
        },

        plotOptions: {
            pie: {
                states: {
                    hover: {
                        enabled: false,
                        brightness: 0
                    },
                    inactive: {
                        enabled: false
                    }
                },
            },
            series: {
                borderWidth: 0,
                colorByPoint: true,
                type: 'pie',
                size: '72px',
                innerSize: '80%',
                dataLabels: {
                    enabled: false,
                }
            }
        },
        colors: [color, "#E8EDF5"],
        series: [{
            name: 'Share',
            data: [
                {y: value},
                {y: 100 - value}
            ]
        }]
    };

    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    );
};

export default CustomDonutChart;